import { Grid } from "@mui/material";
import { FormikProps } from "formik";
import { forwardRef } from "react";
import CustomSelect from "@/components/CustomSelect";
import FormSection from "@/components/FormSection";
import StepperNumberInput from "@/components/StepperNumberInput";
import {
  GROUP_CAPACITY,
  GROUP_MIN_TO_RUN_MIN,
  GROUP_HELPER_TEXT,
  GROUP_LABEL,
  GROUP_SECTION,
  SESSION_DURATION_OPTIONS,
} from "../group-visit-constant";
import { GroupFormValues } from "../group-visit-types";

export type SessionConfigurationSectionProps = {
  formik: FormikProps<GroupFormValues>;
  disabled?: boolean;
};

/**
 * @author Rajkumar Rathod
 */
const SessionConfigurationSection = forwardRef<
  HTMLDivElement,
  SessionConfigurationSectionProps
>(({ formik, disabled }, ref) => {
  const { values, errors, touched, setFieldValue, handleBlur } = formik;

  return (
    <FormSection
      variant="plain"
      ref={ref}
      id={GROUP_SECTION.SESSION}
      title={GROUP_LABEL.sessionSection}
    >
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <CustomSelect
            label={GROUP_LABEL.sessionDuration}
            name="sessionDurationMinutes"
            required
            options={SESSION_DURATION_OPTIONS}
            value={values.sessionDurationMinutes}
            disabled={disabled}
            disableSortOptions
            handleBlur={handleBlur}
            onChange={(value) => setFieldValue("sessionDurationMinutes", value)}
            error={
              touched.sessionDurationMinutes && errors.sessionDurationMinutes
            }
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <StepperNumberInput
            label={GROUP_LABEL.maxCapacity}
            name="maxCapacity"
            required
            disabled={disabled}
            value={values.maxCapacity}
            min={GROUP_CAPACITY.min}
            max={GROUP_CAPACITY.max}
            step={GROUP_CAPACITY.step}
            onBlur={handleBlur}
            onChange={(value) => setFieldValue("maxCapacity", value)}
            error={touched.maxCapacity && errors.maxCapacity}
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <StepperNumberInput
            label={GROUP_LABEL.minToRun}
            info={GROUP_HELPER_TEXT.minToRun}
            name="minToRun"
            disabled={disabled}
            value={values.minToRun}
            min={GROUP_MIN_TO_RUN_MIN}
            max={Number(values.maxCapacity) || GROUP_CAPACITY.max}
            step={GROUP_CAPACITY.step}
            onBlur={handleBlur}
            onChange={(value) => setFieldValue("minToRun", value)}
            error={touched.minToRun && errors.minToRun}
          />
        </Grid>
      </Grid>
    </FormSection>
  );
});

SessionConfigurationSection.displayName = "SessionConfigurationSection";

export default SessionConfigurationSection;
